








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ScreenDialog, FitButton } from '@tencent/wphk-ui';
import WxSubscribe from '@tencent/wphk-components-wx-subscribe/index.vue';
import { handleSubscribeRes, SUBSCRIBE_TYPE } from '@/business/we-coupons/wx-subscribe';
import { CustomException, elk, language } from '@tencent/ppd-base-libs';
import { i18n } from '@/i18n';
import { showToast } from '@tencent/wphk-components-toast';
import { biBrow, biClick } from '@tencent/fit-bi-sdk';

@Component({
  components: { ScreenDialog, FitButton, WxSubscribe },
})
export default class WxSubscribeDialog extends Vue {
  /** 未订阅模板数 */
  @Prop() unSubscribeTmpIds!: string[];
  /** 订阅弹窗提示内容 */
  @Prop() subscribeTipContent!: string;

  /** 多语言 */
  get lang() {
    return language.getLang();
  }

  /**
   * bi 订阅模板扩展字段
   */
  get biExt() {
    return this.unSubscribeTmpIds.map(tmpId => SUBSCRIBE_TYPE[tmpId].desc).join('、');
  }

  /**
   * 显示弹窗
   */
  showDialog() {
    (this.$refs.subscribeDialog as any).show();
    // 进行埋点
    this.$nextTick(() => {
      biBrow('subscribe.brow', { funSubscribeTmpIds: this.biExt });
    });
  }

  /**
   * 关闭弹窗
   */
  hideDialog() {
    (this.$refs.subscribeDialog as any).hide();
    this.$emit('hideSubscribeDialog');
  }

  /**
   * 订阅前处理
   */
  onClickSubscribe(type: 'onSuccess' | 'onFail') {
    // 订阅按钮点击埋点
    biClick('subscribe.subscribe');
    // 关闭订阅弹窗
    this.hideDialog();
    // 进行埋点
    biClick('subscribe.result', { ftype: type, funSubscribeTmpIds: this.biExt });
  }

  /**
   * 订阅成功
   * @param res
   */
  onSuccess(res) {
    this.onClickSubscribe('onSuccess');
    const hasOneAccept = handleSubscribeRes(res);
    if (hasOneAccept) {
      showToast({
        title: i18n('訂閱成功'),
        duration: 2000,
      });
    }
    elk({
      key: 'wxSubscribe',
      str2: 'success',
      msg: JSON.stringify(res),
    });
  }
  /**
   * 订阅失败
   * @param res
   */
  onFail(res) {
    this.onClickSubscribe('onFail');
    showToast({
      title: i18n('無法訂閲，請咨詢客服'),
      duration: 2500,
    });
    elk({
      key: 'wxSubscribe',
      str2: 'fail',
      msg: JSON.stringify(res),
    });
    new CustomException(res, 'wxSubscribeFail', '调用微信订阅失败');
  }
}
